import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    HostBinding,
    Input,
    OnDestroy,
    OnInit,
    ViewEncapsulation,
} from '@angular/core';
import { FiWrapperTableAdditionalColumns } from '@fi-shared/fi-wrapper-table/fi-wrapper-table-additional-columns';
import { FiChecklistHelperService } from '@fi-shared/checklist/fi-checklist-helper.service';
import { DetectDevicesService } from '@fi-shared/fi-shared-services';
import { IItemsListAction2 } from '@fi-shared/fi-items-list/fi-items-list';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { FiChecklistStoreService } from '@fi-shared/checklist/fi-checklist-store.service';

@Component({
    selector: 'fi-checklist2-list-actions',
    templateUrl: './fi-checklist2-list-actions.component.html',
    styleUrls: ['./fi-checklist2-list-actions.component.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: { class: 'fi-checklist2-list-due-date' },
    providers: [{ provide: FiWrapperTableAdditionalColumns, useExisting: FiChecklist2ListActionsComponent }],
    standalone: false,
})
export class FiChecklist2ListActionsComponent extends FiWrapperTableAdditionalColumns implements OnInit, OnDestroy {
    @Input({ required: true }) actions: IItemsListAction2[];
    actionsChanged$ = new Subject<void>();

    @HostBinding('class.mobile-view') get isMobileView(): boolean {
        return this.detectDevicesService.isMobilePhone();
    }

    constructor(
        private fiChecklistHelperService: FiChecklistHelperService,
        private detectDevicesService: DetectDevicesService,
        private fiChecklistStoreService: FiChecklistStoreService,
        private cdr: ChangeDetectorRef,
    ) {
        super();
    }

    ngOnInit(): void {
        this.fiChecklistStoreService.checklistListDataChanged$.pipe(takeUntil(this.ngOnDestroy$)).subscribe((item) => {
            this.actionsChanged$.next();
        });
    }

    private ngOnDestroy$ = new Subject<void>();
    ngOnDestroy() {
        this.ngOnDestroy$.next();
        this.ngOnDestroy$.complete();
    }
}
